var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20047 0.807136C8.94047 0.547136 8.52047 0.547136 8.26047 0.807136L5.00047 4.06047L1.74047 0.800469C1.48047 0.540469 1.06047 0.540469 0.800469 0.800469C0.540469 1.06047 0.540469 1.48047 0.800469 1.74047L4.06047 5.00047L0.800469 8.26047C0.540469 8.52047 0.540469 8.94047 0.800469 9.20047C1.06047 9.46047 1.48047 9.46047 1.74047 9.20047L5.00047 5.94047L8.26047 9.20047C8.52047 9.46047 8.94047 9.46047 9.20047 9.20047C9.46047 8.94047 9.46047 8.52047 9.20047 8.26047L5.94047 5.00047L9.20047 1.74047C9.4538 1.48714 9.4538 1.06047 9.20047 0.807136Z",
    fill: "#347AF0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseVector);
export default __webpack_public_path__ + "static/media/closeVector.68e3d7a38e54d70632d3e26fadf2c2de.svg";
export { ForwardRef as ReactComponent };